import { render, staticRenderFns } from "./ListRegistrations.vue?vue&type=template&id=7199b49c&scoped=true&"
import script from "./ListRegistrations.vue?vue&type=script&lang=js&"
export * from "./ListRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./ListRegistrations.vue?vue&type=style&index=0&id=7199b49c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7199b49c",
  null
  
)

export default component.exports